import { eachDayOfInterval, endOfWeek, startOfWeek } from 'date-fns';

export function getWeekDates(date: Date): Date[] {
  // App is Polish/EU; weeks start on Monday. date-fns defaults to Sunday
  // unless we pass weekStartsOn explicitly.
  const start = startOfWeek(date, { weekStartsOn: 1 });
  const end = endOfWeek(date, { weekStartsOn: 1 });

  return eachDayOfInterval({ start, end });
}
